import {
  FETCH_CART_ITEM,
  FETCH_CART_ITEM_SUCCESS,
  FETCH_CART_ITEM_FAILED
} from '../../types';

const initialState = {
  carts: {},
  isLoading: false,
  errors: {},
  error: false
}

const fetchCartItemReducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_CART_ITEM:
      return {
        ...state,
        isLoading: true,
          carts: action.payload
      }
      case FETCH_CART_ITEM_SUCCESS:
        return {
          ...state,
          isLoading: false,
            carts: action.payload
        }
        case FETCH_CART_ITEM_FAILED:
          return {
            ...state,
            isLoading: false,
              errors: action.payload,
              error: true
          }
          default:
            return {
              ...state
            };
  }
}

export default fetchCartItemReducer;
